<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <!-- brand logo -->


      <v-row class="auth-row ma-0">
        <v-col
          lg="8"
          class="d-none py-0 px-0 d-lg-block"

        >
        <div style="align-items: center; justify-content: center;  display: flex;  width: 100%; height: 100%;  -webkit-align-items: center;">
          <v-img :src="require(`@/assets/images/banner-login.png`)" style="max-width:500px;"></v-img>
        </div>

        </v-col>

        <v-col
          lg="4"
          class="d-flex align-center pa-10 pb-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"

            >
              <v-card flat v-if="tokenValidated && !passwordRecovered">
                <v-card-text>
                  <p
                    class="text-2xl font-weight-semibold text--primary mb-2"
                  >
                  {{$t('Recuperar contraseña')}}
                  </p>
                  <p class="mb-2">
                    {{$t('Ingresa tu nueva contraseña')}}.
                  </p>
                </v-card-text>

                <!-- login form -->
                <v-card-text>
                  <v-form ref="recoverPassword" @submit.prevent="recoverPassword">
                    <v-row>
                      <v-col cols="12" md="12">
                      <v-text-field
                        ref="password"
                        v-model="form.password"
                        :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                        :rules="[() => !!form.password || $t('Campo requerido')]"
                        :type="!showPassword ? 'password' : 'text'"
                        @click:append="showPassword = !showPassword"
                        name="input-10-1"
                        outlined
                        dense
                        autocomplete="off"
                        hide-details="auto"
                        :label="$t('Nueva contraseña')"
                        />
                    </v-col>

                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-btn
                        block
                        color="primary"
                        type="submit"
                        class="mt-6"
                        >
                          {{$t('Cambiar')}}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
              <v-card flat v-if="!tokenValidated">
                <v-card-text>
                  <p
                    class="text-2xl font-weight-semibold text--primary mb-2"
                  >
                  {{$t('Token inválido o expirado')}}.
                  </p>
                  <p class="mb-2">
                    {{$t('Por favor intentelo con un nuevo token')}}.
                  </p>
                </v-card-text>

                <v-card-text>
                  <v-row>
                      <v-col cols="6">
                        <v-btn
                          block
                          color="primary"
                          class="mt-6"
                          @click="() => $router.push('/login')"
                        >
                          {{$t('Volver')}}
                        </v-btn>
                      </v-col>
                    </v-row>
                </v-card-text>
              </v-card>

              <v-card flat v-if="passwordRecovered">
                <v-card-text>
                  <p
                    class="text-2xl font-weight-semibold text--primary mb-2"
                  >
                  {{$t('Contraseña cambiada correctamente')}}!
                  </p>
                  <p class="mb-2">
                    {{$t('Ahora puede iniciar sesión con su nueva contraseña')}}.
                  </p>
                </v-card-text>

                <v-card-text>
                  <v-row>
                      <v-col cols="6">
                        <v-btn
                          block
                          color="primary"
                          class="mt-6"
                          @click="() => $router.push('/login')"
                        >
                          {{$t('Iniciar sesión')}}
                        </v-btn>
                      </v-col>
                    </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <alert-pop-up ref="alert_pop_up"/>
  </div>
</template>

<script>
import AlertPopUp from '@/components/AlertPopUp.vue';
import {
    mdiClockTimeFourOutline,
    mdiClose,
    mdiEye,
    mdiEyeOff,
    mdiPlusCircleOutline
  } from '@mdi/js'

export default {
  data: () => {
    return {
      form: {
        password: '',
      },
      showPassword: false,
      tokenValidated: false,
      passwordRecovered: false
    }
  },
  components: {
    AlertPopUp
  },
  methods: {
    async validateToken() {
      let url = window.location
      let token = new URLSearchParams(url.search).get('t');
      try {
        const form = {
          token: token
        }
        const response = await this.$api.validateToken(form)
        this.tokenValidated = response.data.status === 'OK' ? true : false
      } catch(e) {
        console.log(e)
      }
    },

    async recoverPassword() {
      let url = window.location
      let token = new URLSearchParams(url.search).get('t');
      try {
        const form = {
          password: this.form.password,
          token: token
        }

        const response = await this.$api.recoverPassword(form)
        if(response.data.status === 'OK') {
            this.passwordRecovered = true
          }
      } catch(e) {
        console.log(e.response.data.password)
        if(e?.response?.status === 400) {
            this.$refs.alert_pop_up.showPopUp({ message: this.$t(e?.response?.data?.password[0]), type: 'error' })
          }
      }
    }

  },
  mounted() {
    this.validateToken()
  },
  setup() {
    return {
      icons: {
        mdiEye,
        mdiEyeOff
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
</style>
